var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDates = function SvgDates(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3307 2.00012H1.66406C0.327964 2.00012 0.333496 3.33451 0.333496 3.33451L0.333498 14.0012C0.333498 15.3335 1.66406 15.3335 1.66406 15.3335H12.3307C12.3307 15.3335 13.6668 15.3345 13.6668 14.0012V3.33451C13.6668 3.33451 13.6641 2.00012 12.3307 2.00012ZM1.66594 3.99824C1.66594 3.33345 2.3326 3.33157 2.3326 3.33157H11.6659C11.6659 3.33157 12.3326 3.33157 12.3326 3.99824V13.3316C12.3326 13.9982 11.6659 13.9982 11.6659 13.9982H2.3326C2.3326 13.9982 1.66594 13.9982 1.66594 13.3316V3.99824Z",
    fill: "#777776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00155 7.33223C0.633356 7.33223 0.33488 7.03376 0.33488 6.66557C0.33488 6.29738 0.633356 5.9989 1.00155 5.9989H13.0015C13.3697 5.9989 13.6682 6.29738 13.6682 6.66557C13.6682 7.03376 13.3697 7.33223 13.0015 7.33223H1.00155Z",
    fill: "#777776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 1.33317C9.00016 0.964981 9.29864 0.666504 9.66683 0.666504C10.035 0.666504 10.3335 0.964981 10.3335 1.33317V3.99984C10.3335 4.36803 10.035 4.6665 9.66683 4.6665C9.29864 4.6665 9.00016 4.36803 9.00016 3.99984V1.33317Z",
    fill: "#777776"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66683 1.33317C3.66683 0.964981 3.96531 0.666504 4.3335 0.666504C4.70169 0.666504 5.00016 0.964981 5.00016 1.33317V3.99984C5.00016 4.36803 4.70169 4.6665 4.3335 4.6665C3.96531 4.6665 3.66683 4.36803 3.66683 3.99984V1.33317Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dates.bf22650e.svg";
export { ForwardRef as ReactComponent };